import { InjectionToken, Injector, makeStateKey, TransferState } from '@angular/core';

import { PageRegistryDto } from '../dtos/page-registry.dto';
import { isPlatformServer, Location } from '@angular/common';
import { parseUrlPath } from '../helpers/parse-url-path.function';
import { PageRegistryService } from '../services/page-registry.service';
import { Router, Routes } from '@angular/router';
import { RU_ROUTE_PREFIX, UA_ROUTE_PREFIX } from '../constants';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export const PAGE_TOKEN = new InjectionToken<PageRegistryDto>('page_token');
export const PAGE_STATE_KEY = makeStateKey<PageRegistryDto>('page_state_key');

export function routeResolver(
  injector: Injector,
  state: TransferState,
  platformId: any,
  location: Location,
  pageRegistryService: PageRegistryService,
  router: Router,
) {
  return () => {
    if (isPathInRoutes(location.path(), router.config)) {
      return;
    }

    let currentPage: PageRegistryDto | null;

    if (isPlatformServer(platformId)) {
      currentPage = injector.get(PAGE_TOKEN, null); // token is present only in Server & if dynamic page is requested
      state.set(PAGE_STATE_KEY, currentPage);
    } else {
      currentPage = state.get(PAGE_STATE_KEY, null);
    }

    if (currentPage) {
      pageRegistryService.updateRouterConfig([currentPage]);
    } else {
      const { slug } = parseUrlPath(location.path());

      return pageRegistryService.fetchPageAndUpdateRouterConfig$(slug).pipe(catchError(() => of(null)));
    }
  }
}

export const isPathInRoutes = (path: string, routes: Routes): boolean => {
  const { urlObject } = parseUrlPath(path);
  let pathname = urlObject.pathname || '';
  if (pathname.startsWith('/')) { pathname = pathname.slice(1); }
  const segments = pathname.split('/');
  if (segments[0] !== UA_ROUTE_PREFIX) {
    segments.unshift(RU_ROUTE_PREFIX);
  }

  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    const route = routes.find(r => r.path === segment);

    const isLastSegment = i === segments.length - 1;
    if (!route) {
      return false;
    }

    if (isLastSegment) {
      return true;
    } else {
      routes = route.children || [];
    }
  }
};
